export const __DEV__ = process.env.NODE_ENV === "development";
export const __DEV_OR_STAGE__ =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ENV === "stage" ||
  process.env.REACT_APP_ENV === "staging";
export const SECURITY_KEY = import.meta.env.VITE_SECURITY_KEY;

/** Duration (ms) the eligibility success modal is shown before auto-closing. Not user-closable. */
export const ELIGIBILITY_SUCCESS_MODAL_DURATION_MS = 3000;

/** Fixed lock window (ms) for eligible-website card timer progress (2 hours). */
export const TRANSFER_DISCLAIMER_COUNTDOWN_MS = 2 * 60 * 60 * 1000;

/** `affiliatesTimers[].aggregatorName` for flights hero / tab / lock banner. */
export const AFFILIATE_HERO_TIMER_IMPACT = "IMPACT";

/** `affiliatesTimers[].aggregatorName` for hotels & attractions hero timer. */
export const AFFILIATE_HERO_TIMER_TRAVEL_PAYOUTS = "TravelPayouts";

/** API returns affiliate timer in milliseconds (e.g. 4146560 = ~1h09m). If false, we use value as ms as-is. */
export const AFFILIATE_TIMER_API_IS_SECONDS = false;

/** ILS per 1 USD until `usdExchangeRate` is returned from getTsInitialData. */
export const FALLBACK_USD_EXCHANGE_RATE = 2.895;

export const customUiForIframeCreditGuard = {
  uiCustomData: {
    disableTxnRedirectPopup: true,
    disableRetryOnFailure: true,
    skipPaymentMethodsScreen: true,
    uiLang: "heb",
    customText: {
      "cg-submit-btn": "אימות והמשך",
      "label-expYear": "תוקף",
      "label-card-number": "מספר כרטיס",
      "expYear-ph": "שנה",
      "expMonth-ph": "חודש",
      "label-cvv": "3 ספרות בגב הכרטיס",
      "error-card-number": "מספר כרטיס לא תקין",
    },
    customStyle:
      ":root{--cg-prime:#1C2333;" +
      "--cg-second:#5c64ff;" +
      "--cg-turquois:#0EAAD1;" +
      "--cg-suc:transparent;" +
      "--cg-err:#EE4D3B;" +
      "--cg-gray:#B9B9BA;" +
      "--cg-lightgray:#F6F6F6" +
      "}" +
      "*{direction:rtl;}" +
      "app-number-of-payments{display:none!important;}" +
      "#cg-clear,#cg-footer,#cg-secure-payment,#cg-shadow,#cg-tx-form.cg-block-title,#cg-tx-info,#shield-icon,app-root>img:first-child,#cg-header,app-header,#cg-header-wrapper,#logo-icon,#cg-business-logo,#cg-form-group-card-token,#cg-form-group-card-number,#cg-form-group-expYear,#cg-form-group-expMonth{display:none!important}" +
      "#cg-tx-container,#cg-tx-data,#cg-tx-form{padding:0!important;border:none!important;}" +
      "app-root,#cg-container,#cg-section{display:flex;flex-direction:column;align-items:center;width:100%!important;}" +
      "#cg-form{justify-content:center;align-items:center;margin:0 auto;width:100%;}" +
      "#cg-section{overflow:hidden;min-height:unset!important;}" +
      "#cg-container{border:none;border-radius:0;background-color:transparent!important}" +
      "#cg-section,#cg-tx-container,#cg-popup-wrapper{background:transparent!important;}" +
      "#cg-tx-container{border-radius:0;margin:15px auto 0;width:100%;max-width:320px;display:flex;justify-content:center;}" +
      "#cg-tx-form{min-height:0!important;margin:0 auto;width:100%;max-width:320px;}" +
      "#cg-form-title, .text-danger {display:none}" +
      "#cg-tx-form .form-group,.form-control-label{color:#525355;}" +
      ".form-group{margin:0;}" +
      "#cg-tx-form .cg-input{color:#525355; border-radius: 64px; border: 1px solid #DFDFDF;height:46px;padding: 0 28px;text-align:right;}" +
      "#cg-tx-form .cg-group-input input,select{background:#fff; height:46px; color: #1D1C1D;font-size: 16px; appearance: none!important;}" +
      "#cg-form-group-cvv{flex:unset!important;max-width:100%!important;width:100%!important;margin-bottom:0!important;}" +
      "#cg-form-group-cvv .form-group{display:flex;flex-direction:column;align-items:center;gap:8px;margin:0!important;padding:0!important;border:none!important;background:transparent!important;}" +
      "#cg-form-group-cvv .form-control-label,#cg-form-group-cvv .cg-label-input{display:block;width:100%;margin:0!important;color:rgba(60,61,63,1)!important;font-family:Rubik,sans-serif;font-size:18px;font-weight:400;line-height:1.5;text-align:center;}" +
      "#cg-form-group-cvv lib-textbox{width:100%;}" +
      "#cg-form-group-cvv lib-textbox .test{position:relative;display:flex;justify-content:center;align-items:center;width:100%;border:1px solid #d9d9d9;border-radius:8px;background:#fff;padding:16px;box-sizing:border-box;}" +
      "#cg-form-group-cvv .help_cvv{display:none!important;}" +
      "#cg-form-group-cvv .cg-input,#cg-form-group-cvv #cvv,#cg-form-group-cvv input[name='cvv']{position:relative;z-index:1;width:144px!important;max-width:100%;height:64px!important;border:none!important;border-radius:0!important;background:transparent!important;text-align:center!important;font-size:24px!important;font-weight:500!important;font-family:Rubik,sans-serif!important;color:#3c3d3f!important;padding:0!important;letter-spacing:18px!important;direction:ltr!important;box-shadow:none!important;}" +
      "#cg-form-group-cvv .cg-input:focus,#cg-form-group-cvv #cvv:focus,#cg-form-group-cvv input[name='cvv']:focus{outline:none!important;border:none!important;box-shadow:none!important;}" +
      "#cg-form-group-cvv.ng-invalid lib-textbox .test,#cg-form-group-cvv .ng-invalid lib-textbox .test{border-color:#e74c3c!important;}" +
      "#cg-tx-form lib-field-builder {margin-bottom:20px}" +
      "#cg-tx-form :focus{outline:0;border-color:#b9b9ba!important}" +
      "#cg-tx-form :focus{outline:0;border-color:#b9b9ba!important}" +
      "#cg-tx-form .ng-valid{border-color:var(--cg-suc)}#cg-tx-form lib-field-builder:not(#cg-form-group-card-token):not(#cg-form-group-card-number):not(#cg-form-group-expYear):not(#cg-form-group-expMonth):not(#cg-form-group-cvv),.col-5,.col-3 .col-6{flex:unset;max-width: 48%;}" +
      ".cg-label-input {margin-inline-start: 10px;}" +
      "#cg-form-group-cvv .cg-label-input{margin-inline-start:0!important;}" +
      ".cg-message-input {text-align: start; padding-inline-start: 15px;}" +
      "form #cg-card-brand {left: 20px}" +
      "select {position: relative; appearance: none!important;}" +
      "lib-dropdown::after {font-family: monospace;font-size: 1rem;left: 26px;top: 39px;position: absolute; border-style: solid; border-width: 1px 1px 0 0;display:inline-block; height: 10px; vertical-align: top; width:10px;transform: rotate(135deg) }" +
      "#cg-submit-btn{;background:#e10514;margin:15px auto 0; width: 215px;border-radius: 50px;font-weight: 400;}" +
      "#cg-submit-btn,:active :hover{color:#fff;border-color:#fff;}" +
      "lib-transaction-alert-popup{background-color:#0d1718;border-radius:15px!important;}" +
      "#cg-popup-wrapper{height:unset!important;width:unset!important;}" +
      "#cg-popup-wrapper *{color:white!important;}" +
      "#cg-popup-cancel p{padding:0!important;font-size:14px!important;}" +
      "#cg-popup-cancel span{display:block!important;}" +
      "#cg-popup-title{font-size:25px!important;}" +
      "#cg-popup-p{font-size:16px!important;}" +
      "#cg-popup-wrapper .primary-cg-button{background:#e10514!important;font-size:14px!important;}" +
      "#cg-popup-content{padding:25px 0;}" +
      "#cg-popup-anim{display:none;}" +
      ".primary-cg-button:not([disabled]):hover{background:#e10514!important;border:none!important;}" +
      "#cg-payment-related{margin:0!important}.cg-form-controls{margin:0;}" +
      "@media (min-width: 320px) {" +
      "#cg-tx-form ,#cg-form-group-card-token .form-group,#cg-form-group-card-number .form-group, #cg-tx-form  .form-control-label #cg-tx-form  .form-control-label, #cg-form {width: 320px; max-width: 320px;}" +
      "#cg-tx-form lib-field-builder:not(#cg-form-group-card-token):not(#cg-form-group-card-number):not(#cg-form-group-expYear):not(#cg-form-group-expMonth):not(#cg-form-group-cvv), .col-5, .col-3 .col-6 { width: 147px;}" +
      "#cg-form-group-cvv,#cg-form-group-cvv .form-group,#cg-form-group-cvv lib-textbox .test{width:100%;max-width:100%;}" +
      "}" +
      "@media (max-width: 767px) {" +
      "#cg-form-group-cvv .cg-input,#cg-form-group-cvv #cvv,#cg-form-group-cvv input[name='cvv']{width:120px!important;height:56px!important;font-size:20px!important;letter-spacing:14px!important;}" +
      "#cg-form-group-cvv lib-textbox .test{padding:8px;}" +
      "#cg-form-group-cvv lib-textbox .test::after{bottom:14px;width:24px;height:1.5px;box-shadow:-48px 0 0 #d9d9d9,48px 0 0 #d9d9d9;}" +
      "#cg-form-group-cvv .form-control-label,#cg-form-group-cvv .cg-label-input{font-size:16px;}" +
      "}",
  },
};